export default __webpack_public_path__ + "5da39ea.png";